import { 
  watchlistService as sharedWatchlistService
} from '@watchlist/shared';

// Re-export the shared watchlist service for backward compatibility
export const watchlistService = sharedWatchlistService; 